(()=>{
 document.querySelectorAll('.manual-configurator').forEach(configurator=>{
  const workspace=configurator.querySelector('.configurator-workspace');
  if(!workspace||workspace.querySelector('.configurator-upgrades'))return;
  const standard=workspace.querySelector('.configurator-colors');
  const dimensions=workspace.querySelector('.configurator-layout');
  const divider=standard.querySelector('.upgrades-title');
  if(!divider||!dimensions)return;
  const upgrades=document.createElement('aside');
  upgrades.className='configurator-panel configurator-colors configurator-upgrades';
  upgrades.setAttribute('aria-label','Optional upgrades');
  while(divider.nextSibling)upgrades.append(divider.nextSibling);
  upgrades.prepend(divider);
  standard.classList.add('configurator-standard');
  standard.append(dimensions);
  workspace.append(upgrades);
 });
 const root=document.querySelector('.motorized-configurator');if(!root)return;
 const model=root.querySelector('.configurator-model'),fabric=root.querySelector('.fabric-options');
 const sync=()=>{fabric.hidden=model.dataset.screen!=='screen';};
 root.addEventListener('configurationchange',sync);
 new MutationObserver(sync).observe(model,{attributes:true,attributeFilter:['data-screen']});sync();
})();
